var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "simple-icons:upwork"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.8415 19.737C26.1885 19.737 24.639 19.0365 23.2305 17.8965L23.5725 16.2825L23.5845 16.2195C23.895 14.505 24.858 11.6295 27.843 11.6295C28.9181 11.6303 29.9489 12.0577 30.7091 12.8179C31.4693 13.5781 31.8967 14.6089 31.8975 15.684C31.8955 16.7588 31.4675 17.789 30.7072 18.5488C29.9468 19.3085 28.9163 19.7358 27.8415 19.737ZM27.8415 7.527C24.033 7.527 21.0765 10.0005 19.8765 14.076C18.0465 11.325 16.6545 8.022 15.846 5.238H11.742V15.906C11.7412 16.9192 11.3385 17.8906 10.6222 18.6072C9.90595 19.3237 8.93465 19.7268 7.9215 19.728C6.90887 19.726 5.93834 19.3226 5.22272 18.6061C4.5071 17.8896 4.10479 16.9186 4.104 15.906V5.238H0V15.906C0 20.277 3.555 23.8605 7.9215 23.8605C12.291 23.8605 15.846 20.277 15.846 15.906V14.121C16.6395 15.7815 17.619 17.4645 18.807 18.9525L16.2975 30.762H20.493L22.3125 22.197C23.907 23.2155 25.74 23.8605 27.8415 23.8605C32.3415 23.8605 36 20.1825 36 15.6855C36 11.1855 32.3415 7.527 27.8415 7.527Z",
    fill: "var(--fill-0, #5A5F6A)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwork);
export default __webpack_public_path__ + "static/media/upwork.38c91ddeee58adca8f828d0c8b1bf5f2.svg";
export { ForwardRef as ReactComponent };